import { render, staticRenderFns } from "./LotViewBreadcrumbs.vue?vue&type=template&id=08b85fb2&scoped=true&"
import script from "./LotViewBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./LotViewBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./LotViewBreadcrumbs.vue?vue&type=style&index=0&id=08b85fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b85fb2",
  null
  
)

export default component.exports